import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginFormComponent } from '@spartacus/user/account/components';
import { VISIBILITY } from './btn-visibility/core/btn-visibility.model';

@Component({
  selector: 'cx-login-form',
  templateUrl: './login-form.component.html',
  styleUrl: 'login-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomLoginFormComponent extends LoginFormComponent {
  setInputType(status: VISIBILITY, $input: HTMLInputElement) {
    $input.type = status === VISIBILITY.VISIBLE ? `text` : `password`;
  }
}
